export default __webpack_public_path__ + "static/media/i3.287c69d2.jpg";